


















import FormCommerceKind from '@/components/CommerceKind/form.vue';
import { CommerceKindParams } from '@/store/interfaces/commerceKind';
import commerceKind from '@/store/types/commerceKind';
import { newCommerceKindType } from '@/store/interfaces/BlobImage';
import { mapActions } from 'vuex';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'UpdateCommerceKind',
  components: {
    FormCommerceKind,
  },
  props: {
    editCommerce: {
      required: true,
      type: Boolean,
    },
    commerceKind: {
      required: true,
      type: Object as PropType<CommerceKindParams>,
    },
  },
  data() {
    return {
      clean: false,
      loading: false,
    };
  },
  computed: {
    syncedEditCommerceKind: {
      get(): boolean {
        return this.editCommerce;
      },
      set(val: boolean): void {
        this.$emit('update:editCommerce', val);
      },
    },
  },
  methods: {
    ...mapActions({
      updateCommerceKindList: `commerceModule/commerceKind/${commerceKind.actions.UPDATE_COMMERCE_KIND}`,
    }),
    cancelEditing(): void {
      this.$emit('update:editCommerce', false);
    },
    updateCommerceKind(commerceKind: newCommerceKindType): void {
      this.$data.loading = true;
      this.updateCommerceKindList({
        commerceKind,
        id: this.commerceKind.id,
      })
        .then(() => {
          this.$data.clean = true;
        })
        .finally(() => {
          this.$emit('update:editCommerce', false);
          this.$data.clean = false;
          this.$data.loading = false;
        });
    },
  },
  watch: {
    editCommerce: {
      handler(val: boolean): void {
        if (!val) {
          this.$data.clean = false;
        }
      },
      immediate: true,
    },
  },
});
